import React from 'react'
import { motion } from 'framer-motion'
import { Section } from './ui'
import { ECOSYSTEM_PARTNERS } from '../constants'
import { cn } from '../utils'

const EcosystemSection: React.FC = () => {
  return (
    <Section id="ecosystem" background="muted" padding="xl">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
        <motion.div
          className="lg:col-span-5"
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: '-60px' }}
          transition={{ duration: 0.6 }}
        >
          <p className="text-xs font-medium tracking-[0.22em] uppercase text-secondary-500 dark:text-secondary-300 mb-4">
            Who We Work With
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-gray-900 dark:text-white leading-tight mb-6">
            Partners who want to move beyond conversation.
          </h2>
          <p className="text-lg text-gray-600 dark:text-gray-300 leading-relaxed">
            We work with partners who want to build practical, evidence-informed solutions
            for Africa's digital future.
          </p>
        </motion.div>

        <motion.ul
          className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-3"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-60px' }}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          {ECOSYSTEM_PARTNERS.map((p, i) => (
            <motion.li
              key={p.key}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-40px' }}
              transition={{ duration: 0.35, delay: i * 0.04 }}
              className={cn(
                'flex items-center gap-3 px-4 py-3 rounded-lg',
                'bg-white dark:bg-gray-900',
                'border border-gray-200 dark:border-gray-800',
                'transition-colors duration-200',
                'hover:border-primary-400 dark:hover:border-primary-500'
              )}
            >
              <span
                aria-hidden="true"
                className={cn(
                  'w-2 h-2 rounded-full flex-shrink-0',
                  i % 2 === 0 ? 'bg-primary-400' : 'bg-secondary-400'
                )}
              />
              <span className="text-sm md:text-base text-gray-700 dark:text-gray-200 font-medium">
                {p.label}
              </span>
            </motion.li>
          ))}
        </motion.ul>
      </div>
    </Section>
  )
}

export default EcosystemSection
